import React, { useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import {
  Button,
  Chip,
  IconButton,
  TablePagination,
  Typography,
  Checkbox,
  Box,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";
import { statusList } from "../../data";
import { AuthContext } from "../../context/AuthContext";

import Grid from "@mui/material/Grid2";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

const cash = "/cash.png";
const ucb = "/ucb.png";

const city = "/city.png";

const brac = "/brac.png";

const ssl = "/ssl.png";

const bkash = "/bkash.png";

const due = "/due.png";
const discount = "/discount.png";
const refund = "/refund.png";
let paymentMethodList = [
  { name: "Cash", color: "#FEF7C3", icon: cash },
  { name: "UCB", color: "#FEE4E2", icon: ucb },
  { name: "City", color: "#DCFAE6", icon: city },
  { name: "Brac", color: "#FFE6D5", icon: brac },
  { name: "SSL", color: "#E0E8FF", icon: ssl },
  { name: "Bkash", color: "#EBE9FE", icon: bkash },
];
const TransactionList = ({
  loading,
  pageLoading,
  tableDataList,
  clearFilter,
  handleDeleteDialog,
  message,
}) => {
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);

  console.log(
    "statusList",
    statusList?.find((el) => el.name === "Rework")?.color
  );
  const calculateTotalAmount = (transactionInfo) => {
    return transactionInfo?.length
      ? transactionInfo.reduce((acc, item) => acc + (item.amount || 0), 0)
      : 0;
  };

  const formatPaymentMethods = (transactionInfo) => {
    if (!transactionInfo?.length) {
      return <Typography variant="body2">N/A</Typography>;
    }
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        {transactionInfo.map((item, index) => (
          <Box>
            {item.name} :{" "}
            <Chip
              key={index}
              label={`${item.amount?.toLocaleString() || 0}`}
              size="small"
              variant="outlined"
              sx={{
                backgroundColor: "#F5F5F5",
                color: "#333",
                border: "1px solid #E0E0E0",
                fontSize: "11px",
                height: "24px",
              }}
            />
          </Box>
        ))}
      </Box>
    );
  };

  const formatServiceDetails = (issues, productDetails) => {
    const issueNames = issues?.length
      ? issues.map((item) => item.name).filter(Boolean)
      : [];
    const productNames = productDetails?.length
      ? productDetails.map((item) => item.name).filter(Boolean)
      : [];

    const allNames = [...issueNames, ...productNames];
    return allNames.length > 0 ? allNames.join(", ") : "N/A";
  };

  // Calculate total debit and credit amounts
  const calculateTotals = () => {
    let totalDebit = 0;
    let totalCredit = 0;

    tableDataList.forEach((transaction) => {
      const amount = calculateTotalAmount(transaction.transaction_info);
      if (transaction.transaction_type === "debit") {
        totalDebit += amount;
      } else if (transaction.transaction_type === "credit") {
        totalCredit += amount;
      }
    });

    return { totalDebit, totalCredit };
  };
  const calculatePaymentMethodTotals = () => {
    return paymentMethodList.map((item) => {
      const amount = tableDataList.reduce((acc, transaction) => {
        const paymentAmount =
          transaction.transaction_info.find((info) => info.name === item.name)
            ?.amount || 0;

        if (transaction.transaction_type === "debit") {
          return acc - paymentAmount;
        } else {
          return acc + paymentAmount;
        }
      }, 0);
      // return {
      //   name: item.name,
      //   amount: amount,

      // };
      return (
        <Box key={item.name} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {item.name}:{" "}
          <Chip
            // label={`${item.amount?.toLocaleString() || 0}`}
            label={amount.toLocaleString()}
            size="small"
            variant="outlined"
            sx={{
              backgroundColor: "#F5F5F5",
              color: "#333",
              border: "1px solid #E0E0E0",
              // fontSize: "11px",
              height: "24px",
              fontWeight: "bold",
            }}
          />
        </Box>
      );
    });
  };

  const { totalDebit, totalCredit } = calculateTotals();
  useEffect(() => {
    const { totalDebit, totalCredit } = calculateTotals();
    console.log("totalDebit 11111111111", totalDebit);
    console.log("totalCredit11111111111111", totalCredit);
  }, [tableDataList]);

  return (
    <div>
      {/* Summary Section */}
      <div
        style={{
      
          gap: "20px",
          marginBottom: "20px",
          padding: "16px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          border: "1px solid #e9ecef",
        }}
      >

      <div
        style={{
          display: "flex",
          gap: "20px",
      
       
        
        
      
        }}
      >
        <div
          style={{
            flex: 1,
            textAlign: "center",
            padding: "12px",
            backgroundColor: "#fff",
            borderRadius: "6px",
            border: "1px solid #dee2e6",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#2E7D32",
              fontWeight: "bold",
              marginBottom: "4px",
            }}
          >
            Total Income
          </Typography>
          <Typography
            variant="h4"
            sx={{
              color: "#2E7D32",
              fontWeight: "bold",
            }}
          >
            {totalCredit.toLocaleString()}
          </Typography>
        </div>

        <div
          style={{
            flex: 1,
            textAlign: "center",
            padding: "12px",
            backgroundColor: "#fff",
            borderRadius: "6px",
            border: "1px solid #dee2e6",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#D32F2F",
              fontWeight: "bold",
              marginBottom: "4px",
            }}
          >
            Total Outgoings (Expenses/ refunds)
          </Typography>
          <Typography
            variant="h4"
            sx={{
              color: "#D32F2F",
              fontWeight: "bold",
            }}
          >
            {totalDebit.toLocaleString()}
          </Typography>
        </div>

        <div
          style={{
            flex: 1,
            textAlign: "center",
            padding: "12px",
            backgroundColor: "#fff",
            borderRadius: "6px",
            border: "1px solid #dee2e6",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#1976D2",
              fontWeight: "bold",
              marginBottom: "4px",
            }}
          >
            Net Balance
          </Typography>
          <Typography
            variant="h4"
            sx={{
              color: totalCredit - totalDebit >= 0 ? "#2E7D32" : "#D32F2F",
              fontWeight: "bold",
            }}
          >
            {(totalCredit - totalDebit).toLocaleString()}
          </Typography>
        </div>
      </div>
      <Grid
        container
        spacing={4}
        
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          padding: "10px",
          backgroundColor: "#ffffff",
          mt:2
        }}
      >
        <span style={{ fontWeight: "bold", fontSize: "16px" }}>
          Closing Balance:
        </span>{" "}
        {calculatePaymentMethodTotals()}
      </Grid>
      </div>
      <div
        style={{
          overflowX: "auto",

          minWidth: "100%",
          width: "Calc(100vw - 385px)",
          // padding: "10px 16px 0px",
          boxSizing: "border-box",
        }}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ whiteSpace: "nowrap" }}>Date</TableCell>
              <TableCell style={{ whiteSpace: "nowrap" }}>Name/Phone</TableCell>
              <TableCell style={{ whiteSpace: "nowrap" }}>
                Transaction Info
              </TableCell>

              <TableCell style={{ whiteSpace: "nowrap" }}>
                Repair Service Details
              </TableCell>
              <TableCell style={{ whiteSpace: "nowrap" }}>
                Payment Methods
              </TableCell>

              <TableCell style={{ whiteSpace: "nowrap" }}>
                Total Amount
              </TableCell>
              {/* <TableCell style={{ whiteSpace: "nowrap" }}>Status</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading &&
              tableDataList.length > 0 &&
              tableDataList.map((row, i) => (
                <>
                  <TableRow
                    key={row?._id}
                    // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      {row?.model_name ? row?.model_name : ""}
                      {row?.transaction_source_type?.includes("expense") &&
                        row?.transaction_name}
                      <br />
                      {row?.transaction_source_type?.includes("repair") ? (
                        <span style={{ color: "#424949", fontSize: "12px" }}>
                          {row?.repair_id ? row?.repair_id : ""}
                        </span>
                      ) : row?.transaction_source_type?.includes("warranty") ? (
                        <span style={{ color: "#424949", fontSize: "12px" }}>
                          {row?.warranty_id ? row?.warranty_id : ""}
                        </span>
                      ) : row?.transaction_source_type?.includes("expense") ? (
                        <span style={{ color: "#424949", fontSize: "12px" }}>
                          {row?.expense_id ? row?.expense_id : ""}
                        </span>
                      ) : null}
                      <br />
                      <span style={{ color: "#424949", fontSize: "12px" }}>
                        {moment(row?.created_at).format("DD/MM/YYYY")}
                      </span>
                    </TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {row?.customer_name ? row?.customer_name : "N/A"}
                      <br />
                      {row?.customer_mobile ? row?.customer_mobile : ""}
                    </TableCell>

                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {row?.transaction_name ? row?.transaction_name : "N/A"}
                      <br />
                      <Chip
                        label={
                          row?.transaction_type?.charAt(0).toUpperCase() +
                          row?.transaction_type?.slice(1)
                        }
                        variant="outlined"
                        sx={{
                          backgroundColor:
                            row?.transaction_type === "credit"
                              ? "#E8F5E8"
                              : "#FFEBEE",
                          color:
                            row?.transaction_type === "credit"
                              ? "#2E7D32"
                              : "#D32F2F",
                          border: "none",
                        }}
                      />
                      {/* <span style={{ color: "#666" }}>
                        {row?.transaction_source_id
                          ? Object.entries(row.transaction_source_id)
                              .filter(([key]) => key !== "_id")
                              .map(([, value]) => value)
                              .join(", ") || "-"
                          : "-"}
                      </span> */}
                    </TableCell>

                    <TableCell
                      sx={{ maxWidth: "200px", wordWrap: "break-word" }}
                    >
                      {row?.transaction_name?.includes("Warranty")
                        ? formatServiceDetails(
                            row?.issues[0],
                            row?.product_details[0]
                          )
                        : formatServiceDetails(
                            row?.issues,
                            row?.product_details
                          )}
                    </TableCell>
                    <TableCell
                      sx={{
                        maxWidth: "200px",
                        color: row?.transaction_type === "debit" && "red",
                      }}
                    >
                      {formatPaymentMethods(row?.transaction_info)}
                    </TableCell>

                    <TableCell sx={{ fontWeight: "bold" }}>
                      {calculateTotalAmount(
                        row?.transaction_info
                      ).toLocaleString()}
                    </TableCell>

                    {/* <TableCell>
                      <Chip
                        label={row?.status ? "Active" : "Inactive"}
                        variant="outlined"
                        sx={{
                          backgroundColor: row?.status ? "#E8F5E8" : "#FFEBEE",
                          color: row?.status ? "#2E7D32" : "#D32F2F",
                          border: "none",
                        }}
                      />
                    </TableCell> */}
                  </TableRow>
                </>
              ))}

            {!loading && tableDataList.length < 1 ? (
              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell colSpan={7} style={{ textAlign: "center" }}>
                  <strong> {message}</strong>
                </TableCell>
              </TableRow>
            ) : null}
            {loading && pageLoading()}
          </TableBody>
        </Table>
      </div>
      {/* {tableDataList.length > 0 ? (
        <div>
          <TablePagination
            style={{ display: "block", border: "none" }}
            rowsPerPageOptions={[]}
            count={totalData}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      ) : (
        <br />
      )} */}
    </div>
  );
};

export default TransactionList;
